import "./Calender.css"

export default function Calendar() {
    return (
        <div className="calender">
            <h1>This is the Calender page</h1>
        </div>
    )
}